// bootstrap base
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-switch/dist/js/bootstrap-switch';
import 'bootstrap-datepicker/js/bootstrap-datepicker';
import 'bootstrap-select/dist/js/bootstrap-select';

// bootstrap mods
import './bootstrap_mods/tabbed_nav';
